import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Close } from "sprout-ui-icons";
import { Text, Flex } from "sprout-ui-primitives";
import { media } from "sprout-ui-theme";
import styled from "styled-components";
import { Button } from "../Button";
export const PopoverDialogContextualActionBar = (props)=>{
    const { contextualTitle , leftAction , rightAction  } = props;
    return /*#__PURE__*/ _jsxs(Flex, {
        borderTopLeftRadius: "inherit",
        borderTopRightRadius: "inherit",
        alignItems: "center",
        height: "56px",
        flex: "none",
        children: [
            /*#__PURE__*/ _jsx(Flex, {
                flex: "1",
                alignItems: "center",
                justifyContent: "flex-start",
                pl: 0,
                children: leftAction
            }),
            /*#__PURE__*/ _jsx(Text, {
                as: "span",
                fontWeight: "bold",
                fontSize: 3,
                children: contextualTitle
            }),
            /*#__PURE__*/ _jsx(Flex, {
                flex: "1",
                alignItems: "center",
                justifyContent: "flex-end",
                pr: 3,
                children: rightAction
            })
        ]
    });
};
export const PopoverDialogContextualActionBarCloseButton = styled(Button)`
  ${media.up("small")} {
    display: none;
  }
`;
PopoverDialogContextualActionBarCloseButton.defaultProps = {
    variant: "circle-bright-blue-bg",
    color: "white.100",
    children: /*#__PURE__*/ _jsx(Close, {})
};
export const PopoverDialogContextualActionBarSaveButton = styled(Button)`
  ${media.up("small")} {
    display: none;
  }
`;
PopoverDialogContextualActionBarSaveButton.defaultProps = {
    variant: "bright-teal",
    children: "Save"
};
